import { Column, Table, TableOptions, Typography } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { RenderActionButtons } from '@/components/RenderActionButtons';
import { useCNMCFileUploadsController } from '@/features/cnmcs/hooks/useCNMCFileUploadsController';
import {
  CNMCFileUpload,
  useCNMCFileUploadStore,
} from '@/features/cnmcs/stores/cnmc-files-upload-store';
import { getFileFormat } from '@/utils/files';

import { FILE_UPLOAD_STATE_TO_ICON_DATA } from './constant';

type CNMCFilesTableProps = {
  cnmcId?: string;
};

export function CNMCFilesTable({ cnmcId }: CNMCFilesTableProps) {
  const { t } = useTranslation();
  const { files } = useCNMCFileUploadStore();
  const { removeFile } = useCNMCFileUploadsController();
  const viewedFiles = files.filter(file => file.cnmcId === cnmcId);

  const options: Partial<TableOptions> = {};

  const columns: Column<CNMCFileUpload>[] = [
    {
      id: 'name',
      title: t('Nombre'),
      sortable: true,
      valueFn: item => item.name,
      render: item => <Typography>{item.name}</Typography>,
    },
    {
      id: 'format',
      title: t('Formato'),
      sortable: true,
      valueFn: item => getFileFormat(item.name) ?? '',
      render: item => <Typography className="uppercase">{getFileFormat(item.name)}</Typography>,
    },
    {
      id: 'status',
      title: t('Estado'),
      sortable: true,
      tooltip: t('Estado de la subida del archivo'),
      valueFn: item => item.status,
      render: item => {
        const { icon: Icon, label } = FILE_UPLOAD_STATE_TO_ICON_DATA[item.status];

        return (
          <div className="flex w-full items-center gap-1">
            <Icon />

            <Typography>{label}</Typography>
          </div>
        );
      },
    },
    {
      id: 'actions',
      title: '',
      className: 'items-end',
      width: '5%',
      render: item => (
        <RenderActionButtons
          item={item}
          onDelete={item => {
            if (!cnmcId) {
              return;
            }

            removeFile(item.id);
          }}
        />
      ),
    },
  ];

  return (
    <Table
      data={viewedFiles}
      options={options}
      columns={columns}
      ignoreWrap
      empty_state={{
        title: 'No hemos encontrado ningún archivo todavía',
      }}
    />
  );
}
